import { Label, Switch } from "@heroui/react";

import {
  TariffCategoryEntity,
  useUpdateTariffCategory,
} from "@/features/tariffs/use-tariffs.ts";

export function EditTariffVisibilitySwitch({
  tariffCategory,
}: {
  tariffCategory: TariffCategoryEntity;
}) {
  const { mutateAsync, isPending } = useUpdateTariffCategory({});

  return (
    <Switch
      defaultSelected={tariffCategory.active}
      isDisabled={isPending}
      size="sm"
      onChange={(value) =>
        mutateAsync({
          id: tariffCategory.id,
          name: tariffCategory.name,
          key: tariffCategory.key,
          active: value,
          sortIndex: tariffCategory.sortIndex,
        })
      }
    >
      <Switch.Control>
        <Switch.Thumb />
      </Switch.Control>
      <Switch.Content>
        <Label>Видно всем</Label>
      </Switch.Content>
    </Switch>
  );
}
